import React, { useEffect } from 'react'
import { Typography } from '@mui/material'

import CreateProjectDialog from "../dialogs/create-project"
import SearchTemplate from "../dialogs/search-template"
import { useDispatch, Actions, useSelector, Triggers, useTrigger } from '../../stores/dashboard.store'
import { createBlueprint, postTemplateSave } from "../../api-client/data"
import cls from '../../util/cls'
import AddIcon from '@mui/icons-material/Add'
import SearchIcon from '@mui/icons-material/Search'

import styles from './styles.module.css'

const ProjectSelect = () => {
    const dispatch = useDispatch()
    const { projects, plan } = useSelector()

    const data = useSelector()

    const selectProject = useTrigger(Triggers.SetActiveProject)
    const refreshProjectList = useTrigger(Triggers.RefreshProjectList)
    const refreshAccountPlan = useTrigger(Triggers.RefreshAccountPlan)

    const toggleShowCreate = () => dispatch(Actions.ToggleProjectIsCreating)
    const toggleShowTemplates = () => dispatch(Actions.ToggleShowSearchTemplate)

    const createProject = async (values) => {
        const blueprint = await createBlueprint(values)
        selectProject(blueprint)
        toggleShowCreate()

        refreshProjectList()
    }

    const createTemplateProject = async (values) => {
        const blueprint = await postTemplateSave({
            name: values?.project?.name,
            templateId: values?.template?.id,
        })
        selectProject(blueprint)        
        toggleShowTemplates()
        
        refreshProjectList()
    }

    useEffect(() => {
        refreshProjectList()
        refreshAccountPlan()
    }, [])

    return (
        <div className={styles.projectSelect}>
            {
                projects?.length < plan?.maxProjects && (
                    <>
                        <div className={styles.projectActionsGroup}>
                            <div className={cls(styles.projectAction, styles.bgBlue)} onClick={toggleShowCreate}>
                                <div className={styles.projectActionIcon}>
                                    <AddIcon style={{ fontSize: 20 }} />
                                </div>
                                <div className={styles.projectActionInfo}>
                                    <div className={styles.projectActionTitle}>New Project</div>
                                    <div className={styles.projectActionDescription}>Create New Project</div>
                                </div>
                            </div>

                            <div className={cls(styles.projectAction, styles.bgPurple)} onClick={toggleShowTemplates}>
                                <div className={styles.projectActionIcon}>
                                    <SearchIcon style={{ fontSize: 20 }} />
                                </div>
                                <div className={styles.projectActionInfo}>
                                    <div className={styles.projectActionTitle}>Templates</div>
                                    <div className={styles.projectActionDescription}>Search example templates</div>
                                </div>
                            </div>
                        </div>

                        <CreateProjectDialog onClose={toggleShowCreate} onSubmit={createProject} show={data?.selectProjectMenu?.isCreating == true} />
                        <SearchTemplate onClose={toggleShowTemplates} onSubmit={createTemplateProject} show={data?.selectProjectMenu?.isSearchTemplate}/>
                    </>
                )
            }
            {
                projects?.length > 0 && (
                    <>
                        <Typography variant="h6" style={{ color: 'var(--text-primary)', padding: '10px 0px' }}>Recents</Typography>

                        <div className={styles.projectList}>
                            {
                                projects?.map(x => (
                                    <div
                                        onClick={() => selectProject(x)}
                                        className={styles.projectEntry}
                                    >
                                        <div
                                            className={styles.snapshot}
                                            style={{
                                                backgroundImage: `url(${x?.snapshot})`,
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                            }}
                                        ></div>
                                        <div>
                                            {x?.name}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </>
                )
            }
        </div>
    )
}

export default ProjectSelect
